export function removeFromStorage(key){
  localStorage.removeItem(key);
}

export function addToStorage(key,value){
  localStorage.setItem(key,value);
}